import { render, staticRenderFns } from "./customInfo.vue?vue&type=template&id=80cbbf28&scoped=true&"
import script from "./customInfo.vue?vue&type=script&lang=js&"
export * from "./customInfo.vue?vue&type=script&lang=js&"
import style0 from "./customInfo.vue?vue&type=style&index=0&id=80cbbf28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cbbf28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cbbf28')) {
      api.createRecord('80cbbf28', component.options)
    } else {
      api.reload('80cbbf28', component.options)
    }
    module.hot.accept("./customInfo.vue?vue&type=template&id=80cbbf28&scoped=true&", function () {
      api.rerender('80cbbf28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/uploadFile/customInfo.vue"
export default component.exports